import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { Link } from "react-router-dom";
import { panSubmit } from "../../api";


/**
 * PanCardDetails component displays PAN card details for user confirmation and submission.
 * Handles formatted display, navigation, and KYC submission logic.
 */
const PanCardDetails = ({ login = null }) => {
  const [disbale, setDeisbale] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const panDetails = location.state?.panDetails || {};
  const userEntered = location.state?.userEntered || {};
  const userId = location.state?.userId || {};
  const [redirectUrl] = useState(login ? 'customer' : 'customerCard')


  function formatKey(key) {
    // Split the key by underscores, capitalize each part, and join with spaces
    return key
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  const panKycSubmit = () => {
    setDeisbale(true)
    let data = {
      'pan_number': userEntered.pan_number,
      'iirpl_sap_code': userId,
      'apiresponse': panDetails
    }
    panSubmit(data)
      .then((d) => {
        navigate(`/${redirectUrl}/pancard-uploded/${userId}`);
      })
      .catch((error) => {
        if (error.response.status === 404) {
          alert(error.response.message)
        } else {
          // Handle other errors
          console.error("Error:", error);
        }
      });
  }
  return (
    <>
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-12 pancard-data">
            <div className="text-center mb-7">
              <img
                width="100"
                alt="icon"
                src={toAbsoluteUrl("/media/images/pan-check.png")}
              />
              <h6 className="mt-5">PAN is Valid</h6>
            </div>
            <div className="px-5">
              <h4 className="mb-5">Details Entered As Per You</h4>
              <label>PAN Card Number</label>
              <p>{panDetails?.pan}</p>
            </div>

            <div style={{ background: '#F9FFFB', border: '1px solid #F9FFFB' }} className="card card-border w-lg-600px">
              <div style={{ minHeight: '39px' }} className="card-header p-2">
                <div className="card-title fs-5 p-0">
                  Details As Per The PAN Card
                </div>
              </div>
              <div className="card-body p-2">
                <div className="d-flex flex-column">
                  {Object.entries(panDetails).map(
                    ([key, value]) => value && (
                      <>
                        {key === 'address' ? <>
                          <div key={key} className="border-bottom pt-1">
                            <label className="fw-semibold fs-6">Full Address: </label>{" "}
                            <p>{value?.full_address || '--'}</p>
                          </div>
                          <div key={key} className="border-bottom pt-1">
                            <label className="fw-semibold fs-6">Street:</label>{" "}
                            <p>{value?.street || '--'}</p>
                          </div>
                          <div key={key} className="border-bottom pt-1">
                            <label className="fw-semibold fs-6">City:</label>{" "}
                            <p>{value?.city || '--'}</p>
                          </div>
                          <div key={key} className="border-bottom pt-1">
                            <label className="fw-semibold fs-6">State:</label>{" "}
                            <p>{value?.state || '--'}</p>
                          </div>
                          <div key={key} className="border-bottom pt-1">
                            <label className="fw-semibold fs-6">Pincode:</label>{" "}
                            <p>{value?.pincode || '--'}</p>
                          </div>
                          <div key={key} className="border-bottom pt-1">
                            <label className="fw-semibold fs-6">Country:</label>{" "}
                            <p>{value?.country || '--'}</p>
                          </div>
                        </>
                          : <>
                            {key === 'aadhaar_linked' ? <>
                              <div key={key} className="border-bottom pt-1">
                                <label className="fw-semibold fs-6">Aadhaar Linked:</label>{" "}
                                <p>{'Linked'}</p>
                              </div>
                            </>
                              : <div key={key} className="border-bottom pt-1">
                                <label className="fw-semibold fs-6">{formatKey(key)}:</label>{" "}
                                <p>{value}</p>
                              </div>


                            }
                          </>
                        }
                      </>
                    )
                  )}
                </div>
              </div>
            </div>

            <div className="mt-15 d-flex justify-content-between">
              <Link to={`/${redirectUrl}/pan-card/${userId}`}>
                <button style={{ background: '#112845' }} className="btn  btn-lg w-150px text-white">Back</button>
              </Link>

              {/* <Link to={`${redirectUrl}/pancard-uploded/${userId}`}>
               
              </Link> */}
              <button disabled={disbale} className="btn btn-danger btn-lg btn-hover-success w-150px text-white" onClick={() => panKycSubmit()}>Submit</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PanCardDetails;
